import cheader from '@/components/header/index.vue'
import caside from '@/components/aside/index.vue'

export default {
	name: 'user_customer',
	data() {
		return {
			search: {
				name: '',
				status: ''
			},
			curpage: 1,
			customers: [

			],
			total: 0,
			selectedCustomers: [

			],
			emptyText:"",
			editFormVisiable: false,
			customerDialogShow:false,
			childcustomers:[],
			totalChild:0
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		}
	},
	created() {
		this.index(1)
	},
	components: {
		cheader,
		caside
	},
	methods: {
		go(url) {
			this.$router.push(url)
		},
		customerIndex(page) {
			this.customerDialogShow = true
			this.$http.get('/api/ucenter/findNoneLinkList', {
			  params: {
				userId: this.user.id,
				name: this.search.name,
				page: page,
				pageSize: 10
			  }
			}).then((res) => {
			  res.data.data = res.data.data ? res.data.data : []
			  if (res.data.data.length == 0) {
				this.emptyText = '暂无数据'
			  }
			  this.childcustomers = res.data.data
			  this.totalChild = res.data.total
			})
		  },
		adder(cid) {
			this.$http.post('/api/ucenter/toApplyLink', { userId: this.user.id, customerId: cid }).then((res) => {
				if (res.data.success) {
				this.$message.success('申请成功，等待对方同意')
				this.customerDialogShow = false
				this.childcustomers = []
				}
			})
		},
		editValue(item){
			this.$http.post('/api/ucenter/updateSupRebate', {
			  supplierId: item.user.id,
			  userId: this.user.id,
			  supRebate:item.supRebate
			}).then((res) => {
			  if (res.data.success) {
				this.$message({
				  message: "操作成功",
				  type: 'success'
				});
			  } else {
				this.$message({
				  message: "操作失败",
				  type: 'success'
				});
			  }
			})
		 },
		index(page) {
			this.$http.get('/api/ucenter/customer', { params: { userId: this.user.id, page: page, pageSize: 10, search: this.search } }).then((res) => {
				this.customers = res.data.data
				this.total = res.data.total
			})
		},
		resetForm(form) {
			this.$refs[form].resetFields()
			this.index(1)
		},
		handleSelectionChange(val) {
			this.selectedCustomers = val
		},
		del() {
			this.$confirm('确定删除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let arr = []
				for (let item of this.selectedCustomers) {
					arr.push(item.user.id)
				}
				this.$http.delete('/api/ucenter/customerDel', { data: { userId: this.user.id, customers: arr } }).then((res) => {
					this.$message.info(res.data.message)
					this.index(this.curpage)
				})
			}).catch(() => {

			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/user/customer/index/index.js